import { formatNumber } from '@progress/kendo-intl';
import { FavoriteFolder } from 'src/types/favorite';
import { ShoppingList } from 'src/types/view_shopping_lists/ShoppingList';
import { round } from 'src/utils/number';

export const buildShoppingListTags = (folder: FavoriteFolder): string[] => {
  const tags: string[] = [];

  if (folder.isCopy) {
    tags.push('Copied to You');
  }

  if (folder.isCopied) {
    tags.push('Copied to Others');
  }

  if (folder.isSharedToOthers) {
    tags.push('Shared with Others');
  }

  if (folder.isShare) {
    tags.push('Shared by Owner');
  }

  return tags;
};

export const formatShoppingListGlCodeDisplay = (glCode: string, glDescription: string): string => {
  if (!glCode) {
    return '';
  }

  if (!glDescription) {
    return glCode;
  }
  return `${glCode} ${glDescription}`;
};

export const mapFavoriteFolderToShoppingList = (folder: FavoriteFolder): ShoppingList => ({
  id: String(folder.id),
  title: folder.description,
  owner: folder.owner,
  glCode: folder.glCode ?? '',
  glDescription: folder.glDescription ?? '',
  remainingBalance: formatNumber(round(folder.glCodeBudget ?? 0, 2), 'c2'),
  tags: buildShoppingListTags(folder),
  productCount: folder.productCount ?? 0,
  isShare: folder.isShare,
  isSharedToOthers: folder.isSharedToOthers,
  isCopy: folder.isCopy,
  isCopied: folder.isCopied,
  sourceClientId: folder.sourceClientId ?? '',
});

export const mapFavoriteFoldersToShoppingLists = (folders: FavoriteFolder[]): ShoppingList[] =>
  folders.map(mapFavoriteFolderToShoppingList);
